export const AUTH = 'AUTH';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_USER_DATA = 'AUTH_USER_DATA';
export const LOGIN_DATA_LOAD = 'LOGIN_DATA_LOAD';
export const AUTH_CHANGE_EMAIL = 'AUTH_CHANGE_EMAIL';
export const UPDATE_USER_ROLE = 'UPDATE_USER_ROLE';
